import React from "react";
import QrCornetsOuter from "../qrCornetsOuter";
import { Form } from "react-bootstrap";
import ExternalGradientColor from "./ExternalGradientColor";
import ExternalSingleColor from "./ExternalSingleColor";
import { useDispatch, useSelector } from "react-redux";
import { setIsSingleColorExternalEye } from "../../../../../redux/slices/qrSettings";

function ExternalEye() {
  const { lang, isSingleColorExternalEye } = useSelector((state) => ({
    lang: state.changeLang.language.stepThree,
    isSingleColorExternalEye: state.qrSettings.isSingleColorExternalEye,
  }));

  const dispatch = useDispatch();

  return (
    <section className="bg-white p-3 p-md-4 text-capitalize rounded-1">
      <div className="fw-bold font_title mb-3 mb-md-4 text-capitalize">
        {lang.corners[0]}
      </div>
      <QrCornetsOuter />
      <div
        key="inline-radio"
        className="mb-3 mt-4 d-flex justify-content-start gap-4 fs-7"
      >
        <Form.Check
          checked={isSingleColorExternalEye}
          type="radio"
          label={lang.gradient[0]}
          name="externalColor"
          id="externalColor-single"
          onChange={() =>
            dispatch(setIsSingleColorExternalEye(!isSingleColorExternalEye))
          }
        />
        <Form.Check
          checked={!isSingleColorExternalEye}
          type="radio"
          label={lang.gradient[1]}
          name="externalColor"
          id="externalColor-gradient"
          onChange={() =>
            dispatch(setIsSingleColorExternalEye(!isSingleColorExternalEye))
          }
        />
      </div>
      {isSingleColorExternalEye ? (
        <ExternalSingleColor />
      ) : (
        <ExternalGradientColor />
      )}
    </section>
  );
}

export default ExternalEye;
